import { useCatalogProductIdParams, useGetPdpIntegratedData, usePdpConfig } from '@domains/pdp-common';

import { EpikStylist } from '../components/EpikStylist';
import { useEpickStylist } from '../services/useEpickStylist';

export interface EpikStylistContainerProps {
  className?: string;
}

export const EpikStylistContainer: React.FC<React.PropsWithChildren<EpikStylistContainerProps>> = ({ className }) => {
  const { isZigzagApp } = usePdpConfig();

  const params = useCatalogProductIdParams();
  const { epick_list } = useGetPdpIntegratedData(params);
  const { is_korea, handleItemClick, handleItemImpression } = useEpickStylist();

  if (!is_korea || !epick_list.length || !epick_list) {
    return null;
  }

  return (
    <EpikStylist
      className={className}
      isApp={isZigzagApp}
      list={epick_list}
      onClickItemCard={handleItemClick}
      onImpressionItemCard={handleItemImpression}
    />
  );
};
